/* Luneor — accessibility fixes for third-party widgets (reviews app), product thumbnails and the lightbox.
   Makes clickable review elements keyboard-usable, labels unlabeled selects,
   fixes contrast and gives images a text alternative. */
(function () {
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var T = {
    en: { sort: 'Sort reviews', photo: 'Open review photo', more: 'Read full review', load: 'Load more reviews' },
    fr: { sort: 'Trier les avis', photo: 'Ouvrir la photo de l’avis', more: 'Lire l’avis complet', load: 'Afficher plus d’avis' },
    es: { sort: 'Ordenar opiniones', photo: 'Abrir foto de la opinión', more: 'Leer opinión completa', load: 'Cargar más opiniones' },
    ar: { sort: 'ترتيب التقييمات', photo: 'فتح صورة التقييم', more: 'قراءة التقييم كاملاً', load: 'عرض المزيد' }
  }[lang] || null;
  if (!T) T = { sort: 'Sort reviews', photo: 'Open review photo', more: 'Read full review', load: 'Load more reviews' };

  var ROOTS = '#ez_review_containter, .ez-amrv-wrapp, .ez-modern-wrap, [class*="a-rv-"], #s-rv-form';
  var NATIVE = 'a[href],button,input,select,textarea,summary,[tabindex]';

  function nameFor(el) {
    var cls = (el.className && el.className.baseVal === undefined ? el.className : '') + '';
    if (/btn-load/.test(cls)) return T.load;
    if (el.tagName === 'IMG' || /image|img/.test(cls)) return T.photo;
    return null;
  }

  function makeKeyboardUsable(el) {
    if (el.dataset.a11y) return;
    el.dataset.a11y = '1';
    el.setAttribute('tabindex', '0');
    if (!el.getAttribute('role')) el.setAttribute('role', 'button');
    var n = nameFor(el);
    var hasText = (el.innerText || '').replace(/[.\s›]/g, '').length > 0;
    if (n && (!hasText || /btn-load/.test(el.className + ''))) el.setAttribute('aria-label', n);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        el.click();
      }
    });
  }

  function scan() {
    var roots = document.querySelectorAll(ROOTS);
    for (var r = 0; r < roots.length; r++) {
      var els = roots[r].querySelectorAll('div,span,li,img,p');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.dataset.a11y || el.matches(NATIVE) || el.closest('a[href],button')) continue;
        if (/slider|wrapper|container|grid|comment/.test(el.className + '')) continue; /* layout or text, not controls */
        if (!el.offsetParent) continue;
        if (getComputedStyle(el).cursor !== 'pointer') continue;
        /* only the outermost pointer element, so a card is one tab stop */
        var p = el.parentElement, inner = false;
        while (p && p !== roots[r]) {
          if (p.dataset.a11y || getComputedStyle(p).cursor === 'pointer') { inner = true; break; }
          p = p.parentElement;
        }
        if (!inner) makeKeyboardUsable(el);
      }
    }
    /* label any unlabeled select (reviews sort menu) */
    var sels = document.querySelectorAll('select');
    for (var s = 0; s < sels.length; s++) {
      var sel = sels[s];
      if ((sel.labels && sel.labels.length) || sel.getAttribute('aria-label') || sel.getAttribute('aria-labelledby')) continue;
      sel.setAttribute('aria-label', T.sort);
    }
    /* product thumbnails: describe each photo using the alt text of the matching gallery image */
    var thumbs = document.querySelectorAll('[data-thumbs] button[data-media-id]');
    for (var j = 0; j < thumbs.length; j++) {
      var b = thumbs[j];
      if (b.dataset.a11yAlt) continue;
      var g = document.querySelector('[data-gal] [data-media-id="' + b.getAttribute('data-media-id') + '"] img');
      var alt = g && g.getAttribute('alt');
      if (!alt) continue;
      b.dataset.a11yAlt = '1';
      var im = b.querySelector('img');
      if (im) im.setAttribute('alt', alt);
      b.setAttribute('aria-label', (b.getAttribute('aria-label') || '') + ' — ' + alt);
    }
    /* review images with missing alt */
    var imgs = document.querySelectorAll(ROOTS.split(',').map(function (x) { return x.trim() + ' img:not([alt])'; }).join(','));
    for (var k = 0; k < imgs.length; k++) imgs[k].setAttribute('alt', T.photo);
  }

  /* lightbox: give the enlarged image the alt text of the gallery image it shows */
  function lightboxAlt() {
    var lb = document.querySelector('[data-lb-img]');
    if (!lb || lb.dataset.a11yLb) return;
    lb.dataset.a11yLb = '1';
    new MutationObserver(function () {
      var src = (lb.getAttribute('src') || '').split('?')[0].replace(/_\d+x\d*(?=\.)/, '');
      var match = null;
      document.querySelectorAll('[data-gal] [data-full]').forEach(function (ph) {
        if (!match && ph.getAttribute('data-full').split('?')[0] === src) match = ph.querySelector('img');
      });
      if (!match) {
        var file = src.split('/').pop();
        document.querySelectorAll('[data-gal] img').forEach(function (im) {
          if (!match && file && (im.currentSrc || im.src).indexOf(file.split('.')[0]) > -1) match = im;
        });
      }
      lb.setAttribute('alt', match ? match.getAttribute('alt') : (document.querySelector('h1') || {}).textContent || '');
    }).observe(lb, { attributes: true, attributeFilter: ['src'] });
  }

  /* contrast (WCAG AA 4.5:1) and visible keyboard focus for the reviews widget */
  var css = document.createElement('style');
  css.textContent =
    '.ez-modern-card-comment,.ez-modern-card-name{color:#c9c1b4!important}' +
    '.a-rv-reviews-header [role=button]{color:#e2b07a!important}' +
    '.ez-modern-bar-count{color:#475569!important}' +
    '.ez-modern-avatar{text-shadow:0 0 2px rgba(0,0,0,.85),0 1px 1px rgba(0,0,0,.6)}' +
    '[data-a11y]:focus-visible,.ez-modern-controls select:focus-visible,#frm-aj-rev .form-control:focus-visible,' +
    '#ez_review_containter a:focus-visible,#ez_review_containter button:focus-visible{outline:2px solid #e2b07a!important;outline-offset:2px!important}';
  document.head.appendChild(css);

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(function () { scan(); lightboxAlt(); }, 250); }
  schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
